import { tsValidateArray, tsValidateBoolean, tsValidateOptionalId, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { PathwayTypes } from './types.js';
import { knowledgeManagerDBGroup, Validator_TagGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    type: tsValidateValue([...PathwayTypes]),
    variableIds: tsValidateArray(tsValidateUniqueId),
    tagGroups: tsValidateArray(Validator_TagGroup),
    archived: tsValidateBoolean(false),
    description: tsValidateString(-1, false),
    version: tsValidateString(),
    underConstruction: tsValidateBoolean(false),
    scoreReferences: tsValidateArray({
        variableId: tsValidateOptionalId,
        mdCalcUrl: tsValidateString(-1, false)
    }),
    pathwayHtmlUrl: tsValidateString(-1, false),
};
const Validator_GeneratedProps = {
    _originalPathway: tsValidateOptionalId,
    _parentId: tsValidateOptionalId,
    _tagIds: tsValidateArray(tsValidateUniqueId),
    _variableIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_Pathway = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: ['_parentId', '_originalPathway', '_tagIds', '_variableIds'],
    versions: ['1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'pathway',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'pathway'
    },
    backend: {
        name: 'pathway'
    },
    entityName: 'Pathway',
    dependencies: {
        '_variableIds': {
            dbKey: 'variables',
            fieldType: 'string[]'
        },
        '_tagIds': {
            dbKey: 'tags',
            fieldType: 'string[]'
        },
        '_parentId': {
            dbKey: 'pathway',
            fieldType: 'string'
        }
    }
};
//# sourceMappingURL=db-def.js.map